import { Tabs } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Company from '../../../LoginPages/Company';
import Customer from '../../../LoginPages/Customer';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import img2 from '../../../Images/img2.png';
import { variableName } from '../../../variableName';

const constItems = [
    {
        label: 'CUSTOMER',
        key: 'customer',
        children: <Customer />,
    },
    {
        label: 'COMPANY',
        key: 'company',
        children: <Company />,
    },
];

const LoginTabs = () => {
    const [tab, setTab] = useState('customer');
    const history = useHistory();


    const onChange = key => {
        console.log(key);
    };

    return (
        <>

            <div style={{ padding: 18 }}>

                <div className="loginTopIcon" style={{

                }}>
                    <img src={img2} className="newLogo" alt="Logo" />
                    <h2 className="brand-name" style={{ textDecoration: "none" }}>{variableName.outerHeaderName}</h2>
                </div>

                <Tabs
                    onChange={onChange}
                    type="card"
                    items={constItems}
                />




                <div className='btn-group ' style={{ display: "flex" }}>
                    <button className="btn btn-outline-primary" onClick={() => history.push('/ProductList')}>Go to Product List</button>
                    <button className="btn btn-outline-primary" onClick={() => history.push('/ContactUs')}>Contact Us</button>
                    {/* <button className="btn btn-primary" onClick={() => history.push('#PrivacyPolicy')}>Privacy Policy</button> */}
                </div>
            </div>
        </>
    );
};

export default LoginTabs;